import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxesComponent } from './checkboxes.component';
import { InputContainerModule } from '../input-container/input-container.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { IconModule } from '../../icon/icon.module';
import { DotIndicatorModule } from '../../dotindicator/dotindicator.module';

@NgModule({
  declarations: [CheckboxesComponent],
  imports: [
    CommonModule,
    InputContainerModule,
    TooltipModule,
    IconModule,
    DotIndicatorModule,
  ],
  exports: [InputContainerModule, CheckboxesComponent],
})
export class CheckboxesModule {}
